function getCardSrc(type) {
  switch (type) {
    case "amex":
      return "assets/images/cards/amex.png";
    case "dinersclub":
      return "assets/images/cards/dinersclub.png";
    case "discover":
      return "assets/images/cards/discover.png";
    case "elo":
      return "assets/images/cards/elo.png";
    case "jcb":
      return "assets/images/cards/jcb.png";
    case "maestro":
      return "assets/images/cards/maestro.png";
    case "mastercard":
      return "assets/images/cards/mastercard.png";
    case "unionpay":
      return "assets/images/cards/unionpay.png";
    case "visa":
      return "assets/images/cards/visa.png";
    default:
      return "assets/images/cards/default.png";
  }
}

export default getCardSrc;
